var $ = global.jQuery = global.$;

var _Base = require('./_Base');

var Pagination = _Base.extend({
  init: function() {
    var self = this;

    this.$prev = this.$el.find('[data-paging-prev]');
    this.$first = this.$el.find('[data-paging-first]');
    this.$pages = this.$el.find('[data-paging-page]');
    this.$next = this.$el.find('[data-paging-next]');
    this.$last = this.$el.find('[data-paging-last]');

    this.currentPage = 1;
    this.visibleItems = 5;
    this.totalPages = 10;
    this.firstIndex = 1;

    this.classes = {
      current: 'is-current'
    };

    this.$pages.on('click', {self:this}, this._pageClickHandler);

    this.attachEvents();

    this.updateNoOfItems();
    this.updatePages(this.firstIndex);
    this.goToPage(this.currentPage);

    $(window).on('resize orientationchange', function() {
      self.updateNoOfItems();
      self.firstIndex = self.getFirstIndex(self.currentPage);
      self.updatePages(self.firstIndex);
      self.goToPage(self.currentPage);
    });

  },

  updateNoOfItems: function() {
    var wWidth = $(window).width();

    this.visibleItems = wWidth > 600 ? 5 : 3;
  },

  getFirstIndex: function(page) {
    return page < this.firstIndex ? Math.floor(page / this.visibleItems) * this.visibleItems + 1 - this.visibleItems : Math.floor(page / this.visibleItems) * this.visibleItems + 1;
  },

  goToPage: function(page, clickTriggered) {
    if (page >= this.firstIndex && page < this.firstIndex + this.visibleItems) {
      this.$pages.parents('li').removeClass(this.classes.current);
      this.$el.find('[data-paging-page=' + page + ']').parents('li').addClass(this.classes.current);
      this.currentPage = page;
      this.updatePages();
      this.$el.trigger('Paging:changed', [page]);
      if (clickTriggered === true) {
        this.$el.find('[data-paging-page=' + page + ']').focus();
        this.$el.trigger('Paging:clickTriggered', [page]);
      }
    } else if (page > 0) {
      this.firstIndex = this.getFirstIndex(page);
      this.updatePages();
      this.goToPage(page, clickTriggered);
    }
    this.updateDisabledState();
  },

  updateDisabledState: function() {
    if (this.currentPage === 1) {
      this.$first.attr('disabled', 'disabled');
      this.$prev.attr('disabled', 'disabled');
    } else {
      this.$first.removeAttr('disabled');
      this.$prev.removeAttr('disabled');
    }
    if (this.currentPage < this.totalPages) { //TODO - handle fewer pages
      this.$last.removeAttr('disabled');
    } else {
      this.$last.attr('disabled', 'disabled');
    }
    if (this.currentPage === this.totalPages) {
      this.$next.attr('disabled', 'disabled');
    } else {
      this.$next.removeAttr('disabled');
    }
  },

  updatePages: function() {
    var self = this;

    this.$pages.each(function(index) {
      var pageNo = self.firstIndex + index;
      $(this).off('click');
      $(this).attr('data-paging-page', pageNo);
      $(this).find('[data-paging-no]').text(pageNo);

      if (pageNo > self.totalPages || index + 1 > self.visibleItems) {
        $(this).parents('li').hide();
      } else {
        $(this).parents('li').show();
      }

      $(this).on('click', { pageNo: pageNo } , self._pageClickHandler.bind(self));

    });

  },

  _nextClickHandler: function(event) {
    event.preventDefault();
    this.goToPage(this.currentPage + 1, true);
  },

  _prevClickHandler: function(event) {
    event.preventDefault();
    this.goToPage(this.currentPage - 1, true);
  },

  _firstClickHandler: function(event) {
    event.preventDefault();
    this.goToPage(1, true);
  },

  _lastClickHandler: function(event) {
    event.preventDefault();
    this.goToPage(this.totalPages, true);
  },

  _pageClickHandler: function(event) {
    var pageNo = event.data.pageNo;
    event.preventDefault();
    this.goToPage(pageNo, true);
  },

  attachEvents: function() {
    var self = this;

    this.$prev.on('click', this._prevClickHandler.bind(this));
    this.$next.on('click', this._nextClickHandler.bind(this));
    this.$first.on('click', this._firstClickHandler.bind(this));
    this.$last.on('click', this._lastClickHandler.bind(this));
  }
});

module.exports = Pagination;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/Pagination.js
 ** module id = 39
 ** module chunks = 0 1
 **/